import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { IUserMe } from '@app/api/interfaces/user-me.interface';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { UserMeMockService } from '@mock/data-services/user-me-mock.service';

@Injectable({
  providedIn: 'root',
})
export class UserMeApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly MOCK: UserMeMockService
  ) {}

  public get(): Observable<IApiResponse<IUserMe, object>> {
    if (this.MOCK.isMockEnabled()) return this.MOCK.get();

    const url = `${environment.apiBaseUrl}/v1/user`;

    return this.httpClient.get<IApiResponse<IUserMe, object>>(url, {
      withCredentials: true,
    });
  }
}
